type colorUnion = | "ruby"
    | "blue"
    | "brown"
    | "crimson"
    | "cyan"
    | "gold"
    | "gray"
    | "green"
    | "indigo"
    | "lime"
    | "orange"
    | "pink"
    | "plum"
    | "purple"
    | "red"
    | "teal"
    | "tomato"
    | "violet"
    | "yellow"
    | "bronze"
    | "amber"
    | "iris"
    | "jade"
    | "grass"
    | "mint"
    | "sky"
    | undefined;

export const badgeColors: {
  [key: string ]: colorUnion
} = {
  approved: "green",
  rejected: "crimson",
  pending: "indigo",
  withdrawn: "gray",
  waitlisted: "amber",
  draft: "gray",
  published: "green",
  open: "green",
  closed: "red",
  upcoming: "indigo",
  active: "green",
  past: "gray",
  // SponsorCampaign#status
  scheduled: "indigo",
  paused: "amber",
  ended: "gray"
};
